import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'nl2br',
})
export class Nl2BrPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {
    // Constructor vacío necesario para inyectar DomSanitizer
  }

  transform(value: string): any {
    if (!value) {
      return '';
    }

    // Reemplazar todos los caracteres de salto de línea \n con <br>
    const result = value.replace(/\n/g, '<br>');

    // Necesitamos usar bypassSecurityTrustHtml para que Angular no sanitice el HTML
    return this.sanitizer.bypassSecurityTrustHtml(result);
  }
}
